import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=65f31be6&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./register.less?vue&type=style&index=0&id=65f31be6&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f31be6",
  null
  
)

export default component.exports